var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 4.75,
    fill: "white",
    fillOpacity: 0.35,
    stroke: "#E7E7E7",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 18C13.2188 17.1082 13.4645 16.2728 13.8913 15.5575V12.5232H10.8571C9.65278 14.0872 9 15.9934 9 18C9 20.0067 9.65278 21.9128 10.8571 23.4768H13.8913V20.4426C13.4645 19.7272 13.2188 18.8918 13.2188 18V18Z",
    fill: "#FBBD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22.7812L15.8906 24.8906L18 27C20.0067 27 21.9128 26.3472 23.4768 25.1429V22.1119H20.4458C19.7242 22.5403 18.8853 22.7812 18 22.7812V22.7812Z",
    fill: "#0F9D58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8917 20.4426L10.8574 23.4768C11.0959 23.7865 11.3555 24.083 11.6364 24.364C13.3363 26.0638 15.5964 27 18.0004 27V22.7813C16.2558 22.7813 14.7267 21.8419 13.8917 20.4426Z",
    fill: "#31AA52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 18C27 17.4524 26.9504 16.9039 26.8526 16.3696L26.7735 15.9372H18V20.1559H22.2698C21.8552 20.9807 21.2176 21.6536 20.4457 22.1119L23.4768 25.143C23.7864 24.9045 24.083 24.6449 24.3639 24.364C26.0638 22.6641 27 20.404 27 18V18Z",
    fill: "#3C79E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3809 14.6191L21.7537 14.992L24.7369 12.0089L24.364 11.6361C22.6641 9.93618 20.404 9 18 9L15.8906 11.1094L18 13.2188C19.2771 13.2188 20.4778 13.7161 21.3809 14.6191Z",
    fill: "#CF2D48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 13.2188V9C15.5964 9 13.3363 9.93618 11.6364 11.636C11.3555 11.9169 11.0959 12.2135 10.8574 12.5232L13.8917 15.5574C14.7268 14.1581 16.2558 13.2188 18.0004 13.2188V13.2188Z",
    fill: "#EB4132"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.445ac93937498970ed35e5959f1725df.svg";
export { ForwardRef as ReactComponent };